// components/SearchAccordion.js
import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const SearchAccordion = ({
  categories,
  selectedFilters,
  setSelectedFilters,
}) => {
  const [expanded, setExpanded] = useState(Object.keys(categories)[0]);

  const handleAccordionChange = (category) => (_, isExpanded) => {
    setExpanded(isExpanded ? category : false);
  };

  const handleCheckboxChange = (category, option) => (event) => {
    const checked = event.target.checked;
    setSelectedFilters((prev) => ({
      ...prev,
      [category]: {
        ...(prev[category] || {}),
        [option]: checked,
      },
    }));
  };

  return (
    <div>
      {Object.entries(categories).map(([category, options]) => (
        <Accordion
          key={category}
          expanded={expanded === category}
          onChange={handleAccordionChange(category)}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{ fontWeight: "bold" }}>{category}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <FormGroup>
              {options.map((option) => (
                <FormControlLabel
                  key={option}
                  control={
                    <Checkbox
                      checked={!!selectedFilters[category]?.[option]}
                      onChange={handleCheckboxChange(category, option)}
                    />
                  }
                  label={option}
                  sx={{ color: "black" }}
                />
              ))}
            </FormGroup>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default SearchAccordion;
